import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";

// Routes
import routes from "./routes";

import store from "../store";

Vue.use(Router);

// Create a new router
const router = new Router({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

Vue.use(Meta);

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    "/login",
    "/login-test",
    "/signup",
    "/recover",
    "/recover_confirm"
  ];
  console.log("to.path:>>>> ", to.path);
  const authRequired = !publicPages.includes(to.path);
  // const authRequired = !to.path.match('/login')

  const loggedIn = store.getters["auth/isAuthenticated"];

  console.log("authRequired,loggedIn:>>>> ", { authRequired, loggedIn });
  if (authRequired && !loggedIn) {
    // window.location = 'http://localhost'
    // window.location = process.env.VUE_APP_SURA_URL;
    // return next("/login")
  }

  next();
});

export default router;
